import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'
import { fontSizes, spacing } from 'syf-component-library/defaultTheme'
import { Button } from 'syf-component-library/ui/atoms'
import CardRow from 'syf-component-library/ui/atoms/Card/CardRow'
import Grid from 'syf-component-library/ui/patterns/Grid'

export const IconContainer = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.cyanBlue};
  font-size: ${fontSizes.medium}px;
`

export const BarIconContainer = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.ebonyClay};
  font-size: ${fontSizes.large}px;
`

export const AccountImageGrid = styled(Grid)`
  max-width: 100%;
  height: 44px;

  @media ${query.lessThanSmall} {
    max-width: 100px;
  }
`

export const VerticalIconWrapper = styled(Grid)`
  display: block;
  text-align: right;

  @media ${query.greaterThanSmall} {
    display: none;
  }
`
export const CardHeaderRow = styled(CardRow)`
  display: block;
  background-color: ${({ theme }) => theme.lightCyanBlue};

  @media ${query.lessThanSmall} {
    cursor: pointer;
    padding: 0 ${spacing.xsmall}px;
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  max-width: 1200px;
  margin: auto;
  @media ${query.greaterThanMedium} {
    display: grid;
    grid-template-areas: 'accountHeader paymentSubHeader';
  }
  @media ${query.betweenMediumLarge} {
    padding: 0 16px;
  }

  @media ${query.betweenSmallMedium} {
    display: grid;
    position: relative;
    padding: 0 8px;
    grid-template-areas: 'accountHeader accountHeader';
  }
`

export const AccountHeaderGrid = styled.div`
  display: grid;
  grid-template-columns: 56px auto minmax(150px, 1fr) auto;
  width: 100%;
  grid-area: accountHeader;
  @media ${query.greaterThanSmall} {
    grid-template-columns: 40px auto 1fr;
    width: initial;
  }
`

export const AccountHeaderSeparator = styled.div`
  display: flex;
`

export const CloseButton = styled(Button)`
  margin: 0;
  height: auto;
  padding: 0 ${spacing.medium}px;
`
